module.exports = {
        srcSet: __webpack_public_path__ + "50a9341625ec2939-300.webp"+" 300w",
        images: [{path: __webpack_public_path__ + "50a9341625ec2939-300.webp",width: 300,height: 274}],
        src: __webpack_public_path__ + "50a9341625ec2939-300.webp",
        toString: function(){return __webpack_public_path__ + "50a9341625ec2939-300.webp"},
        
        width: 300,
        height: 274
      }